module.exports = __webpack_public_path__ + "img/701.be5bd31f.jpg";